"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = DraggableHeaderRenderer;

var _react = _interopRequireDefault(require("react"));

var _reactDnd = require("react-dnd");

var _useCombinedRef = require("./useCombinedRef");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function DraggableHeaderRenderer(_ref) {
  var column = _ref.column,
      render = _ref.render;

  var _useDrag = (0, _reactDnd.useDrag)({
    type: "COLUMN_DRAG",
    item: {
      key: column.key
    },
    collect: function collect(monitor) {
      return {
        isDragging: monitor.isDragging()
      };
    }
  }),
      _useDrag2 = _slicedToArray(_useDrag, 2),
      isDragging = _useDrag2[0].isDragging,
      drag = _useDrag2[1];

  var _useDrop = (0, _reactDnd.useDrop)({
    accept: "COLUMN_DRAG",
    drop: function drop(_ref2) {
      var key = _ref2.key;

      if (column !== null && column !== void 0 && column.onColumnsReorder) {
        column.onColumnsReorder(key, column.key);
      }
    },
    collect: function collect(monitor) {
      return {
        isOver: monitor.isOver(),
        canDrop: monitor.canDrop()
      };
    }
  }),
      _useDrop2 = _slicedToArray(_useDrop, 2),
      isOver = _useDrop2[0].isOver,
      drop = _useDrop2[1];

  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: (0, _useCombinedRef.useCombinedRefs)(drag, drop),
    style: {
      fontWeight: 600,
      opacity: isDragging ? 0.5 : 1,
      backgroundColor: isOver ? "#ececec" : "inherit"
    }
  }, render({
    column: column
  }));
}